<div class="org-list-box">
    <div>
        <input type="text" placeholder="search..." (input)="searchChanged($event.target.value)" />
    </div>
    <div class="org-list">
        <table>
            <tbody>
                <tr *ngFor="let org of organizations" [ngClass]="{'selected': org.expanded}" >
                    <td><span *ngIf="!org.selected" class="link" (click)="addOrg(org)">include</span></td>
                    <td>{{org.orgName}}</td>
                    <td>{{org.orgShortName}}</td>
                    <td>{{(org.isActive===true)?"Active":"Inactive"}}</td>
                    <td><a (click)="onOrgExpandOrCollapse(org)">
                     <span *ngIf="!org.expanded">(+)</span><span *ngIf="org.expanded">(-)</span> </a></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>